import React from 'react';
import ReactDOM from 'react-dom';

import { createHashHistory } from 'History';
import { Router, Route, useRouterHistory } from 'react-router'
import { syncHistoryWithStore, RouterStore } from 'mobx-react-router';

import { Provider } from 'mobx-react';

import  CubeEngine from 'weaCube';
const CubeRoute = CubeEngine.Route;
const formModeStores = CubeEngine.store;

import window from './util';

const routing = new RouterStore();
let stores = {
    // Key can be whatever you want
    routing: routing,
    ...formModeStores
};
const browserHistory = useRouterHistory(createHashHistory)({
    queryKey: '_key',
    basename: '/'
});

const history = syncHistoryWithStore(browserHistory, stores.routing);


window.cubeStore = formModeStores;
window.weaHistory = history;

class Root extends React.Component {

    render() {
        return (
            <Provider ecId={`${this && this.props && this.props.ecId || ''}_Provider@epakg0`} {...stores}>
                <Router ecId={`${this && this.props && this.props.ecId || ''}_Router@hh2c9s`} history={history}>
                    <Route ecId={`${this && this.props && this.props.ecId || ''}_Route@9uoqir`} name="main" breadcrumbName="入口" path="/main" >
                        {CubeRoute}
                    </Route>
                </Router>
            </Provider>
        )
    }
}

ReactDOM.render(<Root ecId={`${this && this.props && this.props.ecId || ''}_Root@epakg5`} />, document.getElementById('container'));



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/single.tsx